<template>
  <div>
    <div :class="classes" class="cursor-pointer uppercase tracking-wide font-bold text-sm opacity-75" @click="toggleOpen">
      {{ title }}
      <span v-show="!isOpen" class="opacity-75 mt-2 float-right"><svg xmlns="http://www.w3.org/2000/svg" width="11.314" height="7.071" viewBox="0 0 11.314 7.071"><path d="M9.293,12.95l.707.707L15.657,8,14.243,6.586,10,10.828,5.757,6.586,4.343,8Z" transform="translate(-4.343 -6.586)"/></svg></span>
      <span v-show="isOpen" class="opacity-75 mt-2 float-right"><svg xmlns="http://www.w3.org/2000/svg" width="11.314" height="7.071" viewBox="0 0 11.314 7.071"><path d="M10.707,7.05,10,6.343,4.343,12l1.414,1.414L10,9.172l4.243,4.242L15.657,12Z" transform="translate(-4.343 -6.343)"/></svg></span>
    </div>
    <div v-show="isOpen" class="mt-1"><slot></slot></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOpen: true
    }
  },
  props: {
    classes: {
      type: String,
      default: 'text-gray-600'
    },
    title: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen ? this.isOpen = false : this.isOpen = true
    }
  },
  mounted() {
      this.isOpen = this.open
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>